import * as React from 'react';
import { readCookie } from '@zapier/cookies';

function buildAccountSwitcherUrl(accountId) {
  return `/switch-account?account=${accountId}&next=${window.location.pathname}`;
}

const ACCOUNT_COOKIE_NAME = 'currentAccountId';
const ACCOUNT_LOCAL_STORAGE_NAME = 'currentAccountId';

const CurrentAccountIdContext = /*#__PURE__*/React.createContext(undefined);
const useCurrentAccountId = () => React.useContext(CurrentAccountIdContext);

function getAccountIdFromCookie() {
  return parseInt(readCookie(ACCOUNT_COOKIE_NAME), 10);
}

function setLocalStorage(accountId) {
  localStorage.setItem(ACCOUNT_LOCAL_STORAGE_NAME, accountId);
}

function CurrentAccountIdProvider(props) {
  const [currentAccountId, setCurrentAccountId] = React.useState(getAccountIdFromCookie());
  /** Watch current account id cookie for changes */

  async function watchCookie() {
    const idFromCookie = getAccountIdFromCookie(); // Only take action if this is a real change

    if (idFromCookie && idFromCookie !== currentAccountId) {
      // Account id has changed
      setCurrentAccountId(idFromCookie); // Ensure that localStorage is the same as the current cookie value
      // for backwards compatibility

      setLocalStorage(idFromCookie);
    }
  }

  React.useEffect(() => {
    // Read cookie value on a set interval to watch for changes
    const timer = setInterval(watchCookie, 1000); // Ensure that localStorage is the same as the current cookie value
    // for backwards compatibility

    setLocalStorage(currentAccountId);
    /** Remove cookie watcher when we dismount */

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  });
  /** Create provider */

  return /*#__PURE__*/React.createElement(CurrentAccountIdContext.Provider, {
    value: currentAccountId
  }, props.children);
}

export { CurrentAccountIdProvider, buildAccountSwitcherUrl, useCurrentAccountId };
